import { render, staticRenderFns } from "./ed-create-course-material-object.vue?vue&type=template&id=d62481f4&scoped=true&"
import script from "./ed-create-course-material-object.ts?vue&type=script&lang=ts&"
export * from "./ed-create-course-material-object.ts?vue&type=script&lang=ts&"
import style0 from "./ed-create-course-material-object.scss?vue&type=style&index=0&id=d62481f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d62481f4",
  null
  
)

export default component.exports